export const pageSectionIds = {
  generalInformation: 'generalInformation',
  rooms: 'rooms',
  reviews: 'reviews',
  facilities: 'facilities',
  flightInformation: 'flightInformation',
  inlineCsw: 'inlineCsw',
  packageDetails: 'packageDetails',
} as const;

// Gap the sticky trip-overview card keeps from the viewport top on the EVO detail page. The scroll to the
// rooms lands their title at the same distance, so the two line up once the scroll settles.
export const EVO_STICKY_TOP_PX = 24;

export const PROVIDERS = {
  GH: { id: 108, name: 'GH' },
  Expedia: { id: 117, name: 'Expedia' },
  Hotelbeds: { id: 31, name: 'Hotelbeds' },
  Booking: { id: 2, name: 'Booking' },
  JumboTours: { id: 111, name: 'Jumbo Tours' },
  Sunhotels: { id: 113, name: 'Sunhotels' },
  Smyrooms: { id: 115, name: 'Smyrooms' },
  Hotusa: { id: 106, name: 'Hotusa' },
  GT: { id: 3, name: 'GT' },
  Agoda: { id: 120, name: 'Agoda' },
  MTS: { id: 121, name: 'Ots Globe' }, /// MTS in database --> Ots Globe
  Tropikal: { id: 101, name: 'Tropikal' },
  Italcamel: { id: 109, name: 'Italcamel' },
  ElevateDMC: { id: 122, name: 'Elevate DMC' },
};

export const mealPlanClassMap: { [key: string]: BoardClassType } = {
  '1': 'ACCOMODATION_ONLY',
  '2': 'ACCOMODATION_AND_BREAKFAST',
  '3': 'HALF_BOARD',
  '4': 'FULL_BOARD',
  '5': 'ALL_INCLUSIVE',
};
